import type { TSkeletonConfig } from "./skeleton.types";
import { useSkeletonLogic } from "./skeleton.hook";
import * as S from "./skeleton.styles";

const Skeleton = ({
  bgColor = "#e0e0e0",
  numOfElements = 1,
  animationTime,
  testId,
}: TSkeletonConfig) => {
  const { items } = useSkeletonLogic({ numOfElements });

  return (
    <>
      {items.map(({ key, unSyncedAnimationTime, index }) => (
        <S.Wrapper
          key={key}
          animationTime={animationTime || unSyncedAnimationTime}
          bgColor={bgColor}
          data-testid={`placeholder-${testId || index}`}
          data-qa={`placeholder-${testId || index}`}
        >
          <S.ItemConversation>
            <S.ItemConversationContent>
              <S.ItemLeftBox>
                <S.ItemVehicleImage />
                <S.ItemContent>
                  <S.ItemTitle />
                  <S.ItemVehicleInfo />
                  <S.ItemUserName />
                </S.ItemContent>
              </S.ItemLeftBox>
            </S.ItemConversationContent>
            <S.ItemMessage>
              <S.ItemLastMessage />
            </S.ItemMessage>
          </S.ItemConversation>
        </S.Wrapper>
      ))}
    </>
  );
};

Skeleton.displayName = "Skeleton";
export { Skeleton };
